import type { TraceListQuery } from "./traceApi";

export const RANGE_IDS = ["15m", "1h", "6h", "24h"] as const;
export type RangeId = (typeof RANGE_IDS)[number];

const RANGE_MS: Record<RangeId, number> = {
  "15m": 15 * 60_000,
  "1h": 60 * 60_000,
  "6h": 6 * 60 * 60_000,
  "24h": 24 * 60 * 60_000,
};

export interface LogFilters {
  userId: string;
  sessionId: string;
  range: RangeId;
}

export const DEFAULT_LOG_FILTERS: LogFilters = {
  userId: "",
  sessionId: "",
  range: "1h",
};

/** The query for the list; the window ends now, so each load recomputes it. */
export function toListQuery(
  filters: LogFilters,
  now: number = Date.now(),
): TraceListQuery {
  return {
    userId: filters.userId,
    sessionId: filters.sessionId,
    since: new Date(now - RANGE_MS[filters.range]).toISOString(),
  };
}

export function formatDuration(ms: number | null): string {
  if (ms === null) return "-";
  return ms >= 1000 ? `${(ms / 1000).toFixed(2)} s` : `${String(ms)} ms`;
}

export function formatTime(value: string): string {
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? value : date.toLocaleString();
}

export function outcomeTone(
  outcome: string | null,
  errors: number,
): "success" | "error" | "neutral" {
  if (errors > 0) return "error";
  if (outcome === null) return "neutral";
  return outcome === "ok" || outcome === "success" || outcome === "succeeded"
    ? "success"
    : "neutral";
}
